/* --------------------------------------------------
                Imports
-------------------------------------------------- */
import { Controller } from "@hotwired/stimulus"
import { lockBody, unlockBody } from "../shared/body_lock.js"

/* --------------------------------------------------
                Stimulus Modal Controller
-------------------------------------------------- */
export default class extends Controller {
  static targets = [ "background" ]
  static values = { frameId: String }

  connect() {
    if (!!this.data.get("param") && !!this.data.get("paramId")) {
      const newLocation = `${window.location.pathname}?${this.data.get("param")}=${this.data.get("paramId")}`
      history.pushState({ urlPath: newLocation }, "", newLocation)
    }
  }

  show(event) {
    // If triggered by an event, ensure it originated from within this modal
    // This prevents the modal from opening when Turbo preloads other frames
    if (event && event.target && !this.element.contains(event.target)) {
      return
    }

    this.open()
  }

  showFromFrame(event) {
    if (!this.hasFrameIdValue || event.target.id !== this.frameIdValue) return
    if (!event.target.innerHTML.trim()) return

    this.open()
  }

  closeOnSubmitEnd(event) {
    if (!this.element.contains(event.target)) return
    if (!event.detail.success) return

    this.close()
  }

  open() {
    this.element.classList.remove("hidden")
    this.element.setAttribute("aria-hidden", "false")
    lockBody()
  }

  close() {
    this.element.classList.add("hidden")
    this.element.setAttribute("aria-hidden", "true")
    unlockBody()
  }

  closeBackground(event) {
    if (event.target === this.backgroundTarget) {
      this.close()
    }
  }

  closeScroll(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  handleKeyup(e) {
    if (e.code === "Escape" && !this.element.classList.contains("hidden")) {
      this.close()
    }
  }
}
